'use client';

import { useState, type FormEvent } from 'react';
import Link from 'next/link';
import { AuthLayout } from '@/components/auth-layout';

export default function RecoverPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    // TODO: integrar con fce-books-api POST /auth/recover
    setSent(true);
  };

  return (
    <AuthLayout
      eyebrow="Recuperar acceso"
      title="¿Olvidaste tu contraseña?"
      intro="Te enviaremos un enlace para crear una nueva."
      footer={
        <Link href="/iniciar-sesion" className="under" style={{ color: 'var(--ink)', fontWeight: 500 }}>
          ← Volver al inicio de sesión
        </Link>
      }
    >
      {sent ? (
        <div style={{ padding: '20px 22px', background: 'var(--paper-2)', borderRadius: 2, fontSize: 14, color: 'var(--ink-soft)' }}>
          Si <strong>{email}</strong> está registrado, recibirás el enlace en unos minutos. Revisa tu bandeja de entrada y la carpeta de no deseados.
        </div>
      ) : (
        <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <label>
            <div className="eyebrow" style={{ marginBottom: 6 }}>Correo electrónico</div>
            <input
              className="input"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu.correo@dominio.mx"
              required
            />
          </label>
          <button type="submit" className="btn btn-primary" style={{ justifyContent: 'center', marginTop: 8 }}>
            Enviar enlace
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
